module.exports = __webpack_public_path__ + "static/img/third2.24386a0e.png";